import { Map, Record } from "immutable";

import { CLEANING_FREQUENCY } from "@typings/booking";
import { BOOKINGS_TO_VALIDATE_JOB_TYPE } from "@typings/jobs";

import { Job, JobsMap } from "./bookingsToValidate.typings";

export const SingleJobFactory = (input: Job): Record<Job> =>
  Record<Job>({
    firstExecutionDate: "",
    frequency: CLEANING_FREQUENCY.ONCE,
    price: 0,
    currency: "",
    uuid: "",
    jobUuid: "",
    contractUrl: "",
    cancellationProcess: null,
    cancellationState: null,
    bookingServiceType: "" as BOOKINGS_TO_VALIDATE_JOB_TYPE,
  })({
    ...input,
  });

export const JobsFactory = (input: Job[]): JobsMap =>
  input.reduce(
    (acc: JobsMap, item: Job) => acc.set(item.uuid, SingleJobFactory(item)),
    Map(),
  );
